module.exports = __webpack_public_path__ + "img/examine.e749d25a.png";